import React from "react";
import { useTranslation } from "react-i18next";
import { InputField } from "./input-field";

export const CardAmount = () => {
  const { t } = useTranslation("calculator");

  return (
    <div>
      <h5 className="mb-9 text-medium text-primary-content">
        {t("amount_to_invest")}
      </h5>
      <InputField />
    </div>
  );
};
